export default {
  expressID: '平台物流账号配置',
  notAvailable: '抱歉，您尚未开通物流平台帐号，您可以',
  applyOpening: '申请开通',
  bindAccount: '绑定已有的物流平台帐号',
  associateAccount: '关联到商户下其它店铺绑定的物流平台帐号',
  hint: '暂时不提供更换帐号或绑定的功能，因为涉及到物流平台的物流订单以及结算问题。即此操作暂时不可逆且不可变化，请谨慎操作。',
  registerAccount: '申请创建物流平台帐号',
  accountType: '账号类型：',
  accountName: '账户名：',
  password: '密码：',
  comfirmPassword: '确认密码：',
  phone: '手机号：',
  send: '获取验证码',
  verifiCode: '校验码：',
  checkCode: '请查收短信',
  created: '为我自动创建 (不建议)',
  submit: '提交',
  bindFormTitle: '绑定已有的物流平台账号',
  binding: '绑定',
  relevance: '关联到商户下其他店铺绑定的物流平台账号',
  classify: '店铺名 / 物流帐号 / 物流帐号类型',
  relevanceButton: '关联',
  logisticsPlat: '物流平台账号',
  verifyPhone: '校验手机号',
  logisticsPlatAccount: '物流平台帐号类型',
  logisticsKey: '帐号Key',
  perfeeSeller: 'Kilimall 商户',
  requiredTxtAccount: '请输入账号',
  requiredTxtPassword: '请输入密码',
  requiredTxtConfirmPassword: '请再次输入密码',
  requiredTxtPhone: '请输入手机号',
  requiredTxtVerifiCode: '请输入验证码',
  alsoCreateWmsAccount: '同时为我创建 WMS 帐号',
  passwordMustSame: '两次输入的密码不一致',
  wmsHiddenTxt: '当前未公开 WMS 独立面板，故帐号密码暂不可见',
  wmsAccount: 'WMS 帐号',
  notCreated: '未创建',
  apply: '去申请',
  applyWmsAccount: '申请 WMS 帐号',
  applyWmsAccountHint:
    '当前您已具备 XED 物流账号，申请 WMS 账号将与此 XED 物流账号绑定。若此 XED 物流账号也被其他店铺关联，则申请成功后的 WMS 账号也将自动被其他店铺关联，请确认后再执行申请。',
  phoneNumberZero: '请勿包含区号或以 0 开头的号码',
  xedeliveryPassword: '物流密码'
}
